import { DateRangePreset } from "../common/ui/activity/date-filter"

export enum EngagementsTab {
  engagements = "engagements",
  leads = "leads",
  dreamRate = "dreamRate",
  activity = "activity",
  sms = "sms",
  aiAdvisor = "aiAdvisor",
  websiteChats = "websiteChats"
}

export type DateRange = 1000 | 90 | 30 | 7 | 1 | 60

export interface TabDateFilter {
  range: DateRangePreset
  customStartDate: Date | null
  customEndDate: Date | null
}

// Serialized version for Redux state (dates stored as ISO strings)
export interface SerializedTabDateFilter {
  range: DateRangePreset
  customStartDate: string | null
  customEndDate: string | null
}

export interface TabRangeState {
  [key: string]: SerializedTabDateFilter
}
